const getMandatoryFieldsResponseMock = {
  mandatoryFields: [],
};

const getAllMandatoryFieldsForOrderWarrantyFormResponseMock = {
  mandatoryFields: ['completionAtDate', 'totalPriceEstimated', 'mileage'],
};

export const metadaWorkshopServiceCaseApiMock = {
  getMandatoryFieldsResponseMock,
  getAllMandatoryFieldsForOrderWarrantyFormResponseMock,
};
